export default __webpack_public_path__ + "static/media/Blackfriday_Coche_Banners_330x330.1e5de3cd.jpg";